function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M6.459 8.388a.52.52 0 01-.721-.065.494.494 0 01-.119-.32V6.001c-2.607.001-4.202.883-4.778 2.708A.426.426 0 01.432 9 .43.43 0 010 8.557c.134-3.714 1.971-5.872 5.62-6.054V.5c0-.276.229-.5.511-.5.12 0 .236.041.328.116l4.607 3.751a.492.492 0 010 .769L6.459 8.388z"
});

var SvgCurvedArrow = function SvgCurvedArrow(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9"
  }, props), _ref);
};

export default SvgCurvedArrow;